import React from 'react';


const ImageElement = ({ isSelected, handleElementMoveStart, index, element, imageData, arr}) => {
  return (
    <div
      key={`w-${index}`}
      className={isSelected ? 'layerIsSelected' : ''}
      onMouseDown={handleElementMoveStart}
      style={{
        zIndex: arr.length*10 - index*10,
        position: 'absolute',
        left: element.coordinates.x,
        top: element.coordinates.y,
        display: element.hidden ? 'none' : '',
      }}>
      <img
        id={element.name}
        src={imageData?.image}
        style={{
          position: 'relative',
          zIndex: arr.length*10 - index*10 }} />
    </div>
  );
};


export default ImageElement;